import { render } from "./ArrowDown.vue?vue&type=template&id=ddb71f8e&scoped=true"
const script = {}

import "./ArrowDown.vue?vue&type=style&index=0&id=ddb71f8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb71f8e"]])

export default __exports__